import { Utils } from '@pacem/pacem-core';
export function ambientLight(references, group, binding) {
    const key = Utils.uniqueCode();
    const lightReference = `ambient_${key}`;
    const inputColor = references.inputColor, outputColor = references.outputColor;
    if (Utils.isNullOrEmpty(inputColor) || Utils.isNullOrEmpty(outputColor)) {
        throw new Error('Must provide either input and output vertex color parameter names.');
    }
    return {
        // type definitions
        definitions: [`struct AmbientLight {
    color: vec4f,
    intensity: f32
}`, `fn computeAmbient(color: vec4f, light: AmbientLight) -> vec4f {
    return vec4f(light.intensity * color.rgb * light.color.rgb, color.a);
}`],
        // bindings
        bindings: [`@group(${group}) @binding(${binding}) var<uniform> ${lightReference}: AmbientLight;`],
        // modifiers
        modifiers: [`${outputColor} = computeAmbient(${inputColor}, ${lightReference});`]
    };
}
